import React from 'react';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const GeneralNoteEditor = ({
    data,
    onChange,
    user
}) => {
    return (
        <>
           <CKEditor
  style={{ minHeight: '70vh', zIndex: '0' }}
  editor={ClassicEditor}
  data={data}
  disabled={user?.responsibilities === "view" || user?.responsibilities === "approver"}
  config={{
    isReadOnly: user?.responsibilities === "view" || user?.responsibilities === "approver",
    toolbar: [
      'heading',
      'fontColor',
      'fontBackgroundColor',
      'fontSize',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'highlight',
      'removeFormat'
    ],
    fontColor: {
      colors: [
        { color: '#111111', label: 'Black' },
        { color: '#FF0000', label: 'Red' },
        { color: '#00FF00', label: 'Green' },
        { color: '#0000FF', label: 'Blue' },
      ]
    },
    fontBackgroundColor: {
      colors: [
        { color: '#FFFF00', label: 'Yellow' },
        { color: '#111111', label: 'Black' },
        { color: '#FF69B4', label: 'Pink' },
      ]
    }
  }}
  onChange={(event, editor) => {
    if (user?.responsibilities !== "view" && user?.responsibilities !== "approver") {
      const data = editor.getData();
      onChange(data);
    }
  }}
/>

        </>
    )
}

export default GeneralNoteEditor